import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomFormDrawer from '../customFormDrawer';
import Review from './review';
import {
  getAnswerCommentFields,
  getCommentInitialData,
} from '../../../utility/fillSurveyUtils';

const useStyles = makeStyles(() => ({
  root: { display: 'flex', flexDirection: 'column' },
}));

const SurveyHistory = ({ translations, reviews, survey, onLoadNextReview }) => {
  const classes = useStyles();
  const [isCommentDialogOpened, setIsCommentDialogOpened] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [questionId, setQuestionId] = useState(null);

  const questionCommentField = getAnswerCommentFields(true);
  const currentComment = getCommentInitialData(
    selectedSubject?.replied?.[questionId]
  );

  const onOpenCommentDrawer = (subject, qId) => {
    setIsCommentDialogOpened(true);
    setSelectedSubject(subject);
    setQuestionId(qId);
  };
  const handleCloseCommentDrawer = () => {
    setIsCommentDialogOpened(false);
    setSelectedSubject(null);
    setQuestionId(null);
  };

  return (
    <div className={classes.root}>
      {reviews.map((review, index) => {
        return (
          <Review
            key={`review_${review.id}`}
            translations={translations}
            survey={survey}
            review={review}
            reviewIndex={index}
            isQuestionnaire={!!survey?.questionnaire}
            selectedSubject={selectedSubject}
            onViewComment={onOpenCommentDrawer}
            onLoadNextReview={onLoadNextReview}
          />
        );
      })}
      {!survey?.questionnare && (
        <CustomFormDrawer
          translations={translations.addCommentForm}
          titleText={translations.addCommentForm.title.view}
          isOpened={isCommentDialogOpened}
          initialData={currentComment}
          fields={questionCommentField}
          onClose={handleCloseCommentDrawer}
          isInitialValid
          shouldHideSave
          isMiddleWidth
          hasCancelButton
          hideDelete
        />
      )}
    </div>
  );
};

SurveyHistory.propTypes = {
  translations: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
  onLoadNextReview: PropTypes.func.isRequired,
};

export default SurveyHistory;
